import React from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { userChangePassword } from "../../slices/auth/changePassword/thunk";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Input,
  Row,
  Alert,
} from "reactstrap";


const selectProperties = createSelector(
  (state: any) => state.ChangePassword,
  (changePassword) => ({
    changeError: changePassword.changeError,
    changeSuccessMsg: changePassword.changeSuccessMsg,
  })
);

const ChangePassword = () => {
  //meta title
  document.title = "Change Password | WeReload";
  
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const { changeError, changeSuccessMsg } = useSelector(selectProperties);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      currentPassword: "",
      password: "",
      passwordConfirmation: "",
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string()
        .required("Please Enter Your Current Password"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Please Enter Your New Password"),
      passwordConfirmation: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required("Please Confirm Your New Password"),
    }),
    onSubmit: (values) => {
      dispatch(userChangePassword({
        currentPassword: values.currentPassword,
        password: values.password, 
        passwordConfirmation: values.passwordConfirmation
      }, {
        router: {
          navigate
        }
      }));
    },
  });

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bxs-lock h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>Change Password</h4>
                        <p className="mb-5">Enter your current password and new password below</p>

                        <Form>
                          <Row>
                            <div className="mb-3">
                              <Label className="form-label">Current Password</Label>
                              <Input
                                name="currentPassword"
                                className="form-control"
                                placeholder="Enter Current Password"
                                type="password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.currentPassword || ""}
                                invalid={
                                  validation.touched.currentPassword &&
                                  validation.errors.currentPassword
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className="mb-3">
                              <Label className="form-label">New Password</Label>
                              <Input
                                name="password"
                                className="form-control"
                                placeholder="Enter New Password"
                                type="password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.password || ""}
                                invalid={
                                  validation.touched.password &&
                                  validation.errors.password
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                          <Row>
                            <div className="mb-3">
                              <Label className="form-label">Confirm New Password</Label>
                              <Input
                                name="passwordConfirmation"
                                className="form-control"
                                placeholder="Confirm New Password"
                                type="password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.passwordConfirmation || ""}
                                invalid={
                                  validation.touched.passwordConfirmation &&
                                  validation.errors.passwordConfirmation
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        </Form>

                        {changeError ? (
                          <Alert color="danger" style={{ marginTop: "13px" }}>
                            {changeError}
                          </Alert>
                        ) : null}
                        {changeSuccessMsg ? (
                          <Alert color="success" style={{ marginTop: "13px" }}>
                            {changeSuccessMsg}
                          </Alert>
                        ) : null}

                        <div className="mt-4">
                          <button
                            type="submit"
                            className="btn btn-success w-md"
                            disabled={validation.isSubmitting || changeSuccessMsg}
                            onClick={() => validation.handleSubmit()}
                          >
                            Change Password
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>© {new Date().getFullYear()} WeReload</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ChangePassword;
